import { parseChoiceId, protocolLessUrl } from '../../utils/utils';

const singleZoneRecommendation = (json) => {
  if (!json || !json.recommendedItems || json.recommendedItems.length <= 0) {
    return false;
  }
  const { choiceId: encodedChoiceId, productId } = json.recommendedItems[0];

  const { choiceId, headerId, headerText } = parseChoiceId(encodedChoiceId);
  if (!choiceId) {
    return false;
  }

  const recommendedIdsList = json.recommendedItems.map(
    ({
      recommendedItemId: id,
      choiceId: itemChoiceId,
      clickTrackingURL,
      upcs,
      displayUpcImage,
      productType,
      colorName,
      images,
      score,
    }) => ({
      id,
      choiceId: itemChoiceId,
      clickTrackingUrl: protocolLessUrl(clickTrackingURL),
      upcs,
      displayUpcImage,
      productType: productType || 'uncategorized',
      colorName: colorName || '',
      images: images || '',
      score,
    }),
  );

  return {
    choiceId,
    headerId,
    headerText,
    productId,
    encodedChoiceId,
    recommendedIdsList,
    clickTrackingUrlPresent:
      recommendedIdsList.length > 0
      && recommendedIdsList[0].clickTrackingUrl
      && true,
    meta: json.meta || '',
    status: json.status,
    error: json.error,
    content: json.content,
    treatmentId: json.treatmentId,
    productType: json.productType,
    impTag: json.impTag,
  };
};

export default singleZoneRecommendation;
